import { render } from "./Sala.vue?vue&type=template&id=3cecc60a&scoped=true"
import script from "./Sala.vue?vue&type=script&lang=js"
export * from "./Sala.vue?vue&type=script&lang=js"

import "./Sala.vue?vue&type=style&index=0&id=3cecc60a&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cecc60a"]])

export default __exports__